import { render, staticRenderFns } from "./ShopBalance.vue?vue&type=template&id=37ec41c7&scoped=true&"
import script from "./ShopBalance.vue?vue&type=script&lang=js&"
export * from "./ShopBalance.vue?vue&type=script&lang=js&"
import style0 from "./ShopBalance.vue?vue&type=style&index=0&id=37ec41c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec41c7",
  null
  
)

export default component.exports